"use strict";

import config from "./config";
import AppError from "./utils/AppError";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import { i18n, loadLanguageAsync } from "@/plugins/i18n";
import "./plugins/api";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/main.sass";

Vue.config.productionTip = false;

Vue.prototype.$config = config;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
  created() {
    // Set app language
    loadLanguageAsync(
      localStorage.getItem("language") ||
        navigator.language ||
        navigator.userLanguage ||
        "pt"
    );

    // Auto login
    this.$store
      .dispatch("Auth/autoLogin")
      .then(user => {
        if (!user) {
          this.$store.dispatch("Auth/logout");
          this.$store.dispatch("Util/showAuthLoginDialog");
          AppError.handle(new AppError("INVALID_TOKEN"));
          return;
        }

        // Fix issue with redirecting to empty page at app refresh while logged in
        if (this.$router.history.pending !== null) {
          this.$router.replace(this.$router.history.pending.path);
        }
      })
      .catch(err => {
        AppError.handle(err);
      });
  }
}).$mount("#app");
